export default __webpack_public_path__ + "static/media/yawning_moon.87ccdd2e.mp4";